import styles from "../../styles/Client.module.css";
import { Container, Navbar, Nav } from "react-bootstrap";
//comp
import SerchByDate from "../../comp/agree/agreeP/SearchByDate";
import SearchByText from "../../comp/agree/agreeP/SearchByText";
import PaginPage from "../../comp/agree/agreeP/PaginPage";
import SearchByStatus from "../../comp/agree/agreeP/SearchByStatus";
import SearchByLocation from "../../comp/agree/agreeP/SearchByLocation";
import { useAppSelector } from "../../hooks";
import { selectUserData } from "../../redux/reducer/user/userSlice";

//------------------------------------------------------
export default function PageAgreeNav() {
    //redux
    const { user } = useAppSelector(selectUserData);
    //view
    return (
        <Navbar expand="lg" bg="secondary" variant="dark" className={styles.navBarRadius}>
            <Container fluid>
                <Navbar.Brand>UMOWY PRZEDWSTEPNE</Navbar.Brand>

                <Navbar>
                    <Nav>
                        <PaginPage />
                    </Nav>
                    <Nav>
                        <SearchByText />
                    </Nav>
                    <Nav>
                        <SerchByDate />
                    </Nav>
                    <Nav>
                        <SearchByStatus />
                    </Nav>
                    <Nav>{user.role === "A" && <SearchByLocation />}</Nav>
                </Navbar>
            </Container>
        </Navbar>
    );
}
